<template>
<div>
     <div class="md-layout" v-if=false>
              <md-button class="md-dense md-primary"  v-on:click="botao_voltar" v-if="botao_voltar_visible" >
                <md-icon>arrow_back</md-icon>
                Voltar para lista
              </md-button>
         </div>
    <div class="md-layout"  v-if="show_message == 'on' ">
          <div  class="alert alert-success">
                      {{message_text}}
          </div>
    </div>

     <div class="md-layout" v-if="loading">
                 
                  <div class="md-layout-item md-size-100">
                        <md-progress-spinner  :md-diameter="30" md-mode="indeterminate"></md-progress-spinner> {{msg_status}} ..
                  </div>
     </div>

  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
                
            <h4 class="title">Dados Básicos</h4>
          </div>
        </md-card-header>

        <md-card-content>


          
             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Data da Inspeção 
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     <!-- :input="datepicker_inputchanged" -->
                                             <datepicker format="dd/MM/yyyy" :typeable=true inputClass="md-input"
                                                  name="data_validade" v-model="data"
                                                :language="language_date" calendar-button-icon-content="event"
                                                
                                                ></datepicker>
									
									
									
			

                                            </md-field>

                                          <span class="error_input">{{ getErrors('data') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Cliente / Estabelecimento
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="id_cliente"   type="text" placeholder="Cliente / Estabelecimento" v-model="form.id_cliente" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('id_cliente') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Estabelecimento
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="id_estabelecimento"   type="text" placeholder="Estabelecimento" v-model="form.id_estabelecimento" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('id_estabelecimento') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Responsável Controlare
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="id_resp_controllare"   type="text" placeholder="Responsável Controlare" v-model="form.id_resp_controllare" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('id_resp_controllare') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Responsável Local
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="id_resp_local"   type="text" placeholder="Responsável Local" v-model="form.id_resp_local" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('id_resp_local') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Responsável Local
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="responsavel_local"   type="text" placeholder="Responsável Local" v-model="form.responsavel_local" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('responsavel_local') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            id_modelo
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="id_modelo"   type="text" placeholder="id_modelo" v-model="form.id_modelo" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('id_modelo') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            obs
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="obs"   type="text" placeholder="obs" v-model="form.obs" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('obs') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            data_cadastro
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
                                             <datepicker format="dd/MM/yyyy" :typeable=true inputClass="md-input"
                                                  name="data_validade" v-model="data_cadastro"
                                                :language="language_date" calendar-button-icon-content="event"
                                             
                                                ></datepicker>
									
									
									
			

                                            </md-field>

                                          <span class="error_input">{{ getErrors('data_cadastro') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            id_cadastrador
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="id_cadastrador"   type="text" placeholder="id_cadastrador" v-model="form.id_cadastrador" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('id_cadastrador') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            nome_cadastrador
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="nome_cadastrador"   type="text" placeholder="nome_cadastrador" v-model="form.nome_cadastrador" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('nome_cadastrador') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            nota_final
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="nota_final"   type="text" placeholder="nota_final" v-model="form.nota_final" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('nota_final') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            parecer_final
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="parecer_final"   type="text" placeholder="parecer_final" v-model="form.parecer_final" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('parecer_final') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            emails_lista
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="emails_lista"   type="text" placeholder="emails_lista" v-model="form.emails_lista" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('emails_lista') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            audit
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="audit"   type="text" placeholder="audit" v-model="form.audit" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('audit') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            Referência
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
              <md-input  name="referencia"   type="text" placeholder="Referência" v-model="form.referencia" ></md-input>
								
                  
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('referencia') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            seq_ano_mes_cliente
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="seq_ano_mes_cliente"   type="text" placeholder="seq_ano_mes_cliente" v-model="form.seq_ano_mes_cliente" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('seq_ano_mes_cliente') }}</span>
                                </div>
             </div> 

             <div class="md-layout">
                                <label class="md-layout-item md-size-15 md-form-label">
                                            publicado
                                </label>
                                <div class="md-layout-item md-size-50">
                                            <md-field>
                                                     
				 
                 <md-input  name="publicado"   type="text" placeholder="publicado" v-model="form.publicado" ></md-input>
                 
				 
			
   

                                            </md-field>

                                          <span class="error_input">{{ getErrors('publicado') }}</span>
                                </div>
             </div> 

        
        </md-card-content>
      </md-card>
      </div>


              
          <div class="md-layout-item md-size-100">
            <div class="md-layout-item md-size-100" style="text-align: right">

                      <md-button class="md-info" type="button"
                              v-bind:disabled="disableButton"  v-on:click="salvar()" > Salvar</md-button>
                     
                     
                      <md-button class="md-danger"  type="button"
                              v-bind:disabled="disableButton" v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
                              v-on:click="excluir()">Excluir</md-button>

            </div>
          </div>

    
     <md-dialog :md-active.sync="showDialogError" >
      <md-tabs md-dynamic-height>
        
        <md-tab md-label="Erros">
                      <ul class="list-group" v-if="p_validator.errors != null ">
                        <li v-for="(item, index) in p_validator.errors" class="list-group-item" :key="index" style="text-align: left">{{item.msg}}</li>
                      </ul>
                      <center>
                     <md-button class="md-danger"  type="button"  @click="hideModal">OK</md-button>

                      </center>
        </md-tab>            

      </md-tabs>
     </md-dialog>
     
  </div>
  </div>
</template>

<style scoped>
@import '../../../assets/css/validate.css';
@import '../../../assets/css/form_custom.css';
</style>
<script>
import service from '../../../services/InspecaoService';
import autocomplete from '../../../components/Rend/autocomplete';
import filelogo from '../../../components/Rend/filelogo';
import mixin_validator from '../../../library/mixin/validator';
import mixin_util from '../../../library/mixin/util';
import modal from '../../../components/Modal';


import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";

import CardCadastro from '../../../components/CardCadastro';
import vue_select from '../../../components/Rend/vue-select/src/Select.vue';

export default {
  components: {
          autocomplete, filelogo,  modal, Datepicker,  CardCadastro,  vue_select
  }, 
  
  mixins: [   mixin_util, mixin_validator],
  props: ['id_load', 'show_back_button','onBack', 'onSave'],
  data() {
    return {

            acao: "Cadastrar",
            form: {},
            perfis: [],
            clientes: [],
            clientes_list: [],

            show_perfil: false,
            file_upload: null,

            botao_voltar_visible: true,

            loading: true,

            result2: "",
            disableButton: false,


            show_message: "off",
            message_text: "",
            message_type: "success",
            interval_message: null,
            showDialogError: false,

            msg_status: "Carregando",

            show_modal_contacts: false,
            show_sub_form: true,

                           data: null,   
               data_cadastro: null,   

            language_date: ptBR,
    };
  },
   mounted() {
            let self = this;
            this.form = service.getModel();

            this.configureMessages(); 

            if ( this.show_back_button != null && this.show_back_button != undefined  ){
                                     this.botao_voltar_visible = this.show_back_button;
            }


            this.disableButton = true;
            
            if ( this.id_load != null && this.id_load != undefined && this.id_load != ""){
                      service.getById(this.id_load).then( function (response){
                 
                        				if ( response.data.data != null && response.data.data != undefined ){
                                                   			self.form = response.data.data;

                        				}else{
                                                   			self.form = response.data.item;

                        				}
                                           if ( self.form.data != null ){
                                                 var intData = self.getApiDateInt(self.form.data);

                                                 self.data = new Date(intData);
                                            
                       }   
                if ( self.form.data_cadastro != null ){
                                                 var intData = self.getApiDateInt(self.form.data_cadastro);

                                                 self.data_cadastro = new Date(intData);
                                            
                       }   
                           self.loading= false;
                           self.disableButton = false;
                      });

            }else{
                        this.loading= false;
                        this.disableButton = false;
            }

            this.$store.dispatch("setButtonBack", { in_form: true,
                                        rota: "inspecao",
                                        exibe : this.show_back_button,
                                        onBack: this.onBack } );
             //this.$store.dispatch("user/save", this.tmpUser)
             
  },
    methods: {
      
        	botao_voltar(){
        		var self = this;

                 if ( this.onBack != null && this.onBack != undefined ){
                 	  this.onBack( self );
                 }
          },
           changed(prop){

           },
          
          configureMessages(){

                       const dict = {
                             // email: {
                             //   required: 'O e-mail não pode ser vazio!',
                             //   email: 'É necessário informar um e-mail válido!'
                             // },
                              nome: {
                                required: 'Nome não pode ser vazio!'
                              },
                             // cnpj: {
                             //   required: 'CPF/CNPJ não pode ser vazio!',
                                // cpf: true //testará o método de CPF
                             // }
                           
                          };

                   this.setFieldsValidator(dict);

                  //this.p_validator.localize('en', dict);

          },
          onPreSaveContatos(){
            this.show_sub_form = false;

          },
          onPosSaveContatos(itens){
            this.show_sub_form = true;

          },
          salvar (){

                var self = this;

        	    	if ( !this.validar() )
                    return false;

                self.msg_status = "Salvando.."; self.loading = true;
                                self.data = Util.dateToBd(  self.data );   
                self.data_cadastro = Util.dateToBd(  self.data_cadastro );   

              
                service.salvar(this.form).then(function(response){

                               
                                var retorno = response.data;
                              
                                self.show_message = "on";
                                self.message_text = "inspecao salvo com sucesso!";

                                self.interval_message = setInterval(self.clear_message, 6000);
                                
                                var item = retorno.item;
                                
                                self.msg_status = "Carregando.."; self.loading = false;
            
                                self.form = item;

                                            
                                if ( self.onSave != null && self.onSave != undefined ){
                                        self.onSave(retorno, 'save');
                                }
                }).catch(function(error){

                });

        	
          },
          
        	excluir(){
            let self = this;
            self.msg_status = "Excluindo.."; self.loading = true;
            
            var fn_return = function(response){
                       var retorno = response.data;
                       if ( self.onSave != null && self.onSave != undefined ){
                                 self.onSave(retorno, 'delete');
                       }
                       self.msg_status = "Carregando.."; self.loading = false;
                       self.botao_voltar();
            }
            if ( this.form.id == null )
               return false;

            service.delete(this.form.id).then(fn_return);
        	//	obj_api.call_delete("cliente", this.id, fn_return);
        	},
          clear_message(){
                 this.show_message = "off";
                 clearInterval(this.interval_message);
        	},
           hideModal() {
                       this.showDialogError = false;
          },
          validar(){
			
                    this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
                    console.log("erros? ");
                    console.log( this.p_validator.errors );

                    if (this.p_validator.errors.length > 0 ){
                                
                               
                              this.showDialogError = true;
                              return false;
                    }

             
                    return true;
           }
    }
};
</script>
